const PREFIX = '@@CHECKPOINT';

export const FETCHED_CHECKPOINT = `${PREFIX}/FETCHED_CHECKPOINT`;
export const START_LOADING_CHECKPOINT = `${PREFIX}/START_LOADING_CHECKPOINT`;
export const END_LOADING_CHECKPOINT = `${PREFIX}/END_LOADING_CHECKPOINT`;
export const UPDATE_CHECKPOINT = `${PREFIX}/UPDATE_CHECKPOINT`;
export const DELETE_CHECKPOINT = `${PREFIX}/DELETE_CHECKPOINT`;
export const CREATE_CHECKPOINT = `${PREFIX}/CREATE_CHECKPOINT`;
